import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {FlexiAddButton} from '@flexinet/ui-components';
import {AddFormDrawer} from '../drawers/AddFormDrawer';
import config from '../config';

// The library's add button, beside its drawer. The console's copy hand-rolled
// the button and REPLACED it with the drawer, so the toolbar lost the button
// while the drawer was open and the drawer had no exit transition.
export const AddRecordButton = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <FlexiAddButton aria-label={I18n.get(`New ${config.titles.singular}`)} onClick={() => setOpened(true)}>
                {I18n.get(`New ${config.titles.singular}`)}
            </FlexiAddButton>
            <AddFormDrawer opened={opened} onClose={() => setOpened(false)}/>
        </>
    );
};
